import moment from "moment/moment";
import {useEmailMessages} from "../../../services/emailMessages";
import MessageDetailsForm from "../../Messages/components/MessageDetailsForm";

const EmailViewer = (props) => {
  const {sourceEmailUuid, queryClient, classes, doNotDisplayTitle} = props;

  const emailRecord = useEmailMessages({queryClient, extraKeys:[sourceEmailUuid], useCache: true});

  if (!emailRecord || !Array.isArray(emailRecord.data) || emailRecord.data.length < 1) return (<></>);
  return (
    <div>
      <MessageDetailsForm canEdit={false} classes={classes} record={emailRecord.data[0]} doNotDisplayTitle/>
    </div>
  )
}

const nextActionDateTime = () => {
  const currentDateTime = moment();
  const endOfCurrentDay = currentDateTime.startOf("day").add(18, "hours");
  const currentWeekDay = currentDateTime.isoWeekday();
  if (currentWeekDay > 5) {
    return moment().add(1, 'weeks').startOf("week").startOf("day").add(12, "hours");
  } else if (currentDateTime.isAfter(endOfCurrentDay) || moment(currentDateTime).add(6, "hours").isAfter(endOfCurrentDay)) {
    return currentDateTime.startOf("day").add(1, "day").add(12, "hours");
  }
  return moment(currentDateTime).add(6, "hours");
}

export {
  nextActionDateTime,
  EmailViewer,
}
